import { UnitDataListReportsDateRange } from '../../utils/unitDataListDateRange';

export type ResolveUnitDataListMainTableEndDateParams = {
  dateRange: UnitDataListReportsDateRange;
  /** お気に入り適用時に画面系統で組み立てた ymdList（カスタムでは保存値） */
  ymdList: readonly string[] | undefined;
  /**
   * お気に入りに保存された endDate。
   * カスタム期間のフォールバックにだけ使う。非カスタムでは値に使わない。
   */
  savedEndDate: string | undefined;
  fallbackEndDate: string;
};

const isPresentDateString = (value: string | undefined): value is string =>
  value !== undefined && value !== '';

/**
 * 台別データ推移の基準となるメインテーブル最終日を決める。
 * 呼び出し側が渡した ymdList の最終日を最優先する。
 */
export const resolveUnitDataListMainTableEndDate = (
  params: ResolveUnitDataListMainTableEndDateParams
): string => {
  const ymdListEndDate = params.ymdList?.at(-1);

  if (isPresentDateString(ymdListEndDate)) {
    return ymdListEndDate;
  }

  if (
    params.dateRange === 'カスタム' &&
    isPresentDateString(params.savedEndDate)
  ) {
    return params.savedEndDate;
  }

  return params.fallbackEndDate;
};
